<template>
  <div class="result__wrapper" v-if="text.length">
    <p class="team-result__text" v-html="text" />
  </div>
</template>
<script>
import Util from '@/util'

export default {
  props: {
    result: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      typeAnswer: '',
      text: '',
    }
  },
  mounted() {
    this.getCorrectTypeAnswerText()
    this.text = this.getTextResult()
  },
  methods: {
    getCorrectTypeAnswerText() {
      if (this.$store.state.slide.slideType === 'typeAnswer') {
        if (this.$store.state.slide.correctQuizTypeAnswer) {
          this.typeAnswer = this.$store.state.slide.correctQuizTypeAnswer
        } else if (
          this.$store.state.slide.otherCorrectQuiz &&
        this.$store.state.slide.otherCorrectQuiz.length
        ) {
          this.$store.state.slide.otherCorrectQuiz.forEach((item) => {
            if (item.title && !this.typeAnswer) {
              this.typeAnswer = item.title
            }
          })
        }
      }
    },
    getTextResult() {
      // https://docs.google.com/spreadsheets/d/1zag4Rutp910q2QnTyxGhS_q4RpoGZTcBKiHcCzQU7-E/edit#gid=0
      const dataCorrectAnswers =
        Util.getDataCorrectAnswers(this.$store.state.slide.SlideOptions, this.result)
      const text = ''
      const { slide } = this.$store.state
      if (this.result.timeout) {
        // H2, H3, H4
        return `${this.textRunOutOfTime()}<br>${this.textYouHaveWonPoint()}.`
      }
      // I2, I3
      if (dataCorrectAnswers.audienceCorrectAnswers.length &&
        dataCorrectAnswers.audienceMissCorrectAnswers !== 0 && !this.result.timeout) {
        return this.textPartiallyCorrect(dataCorrectAnswers)
      }
      // F2, F3, F4, G2, G3, G4
      if (!this.result.timeout &&
      ((slide.multipleChoice && !slide.isCorrectGetPoint) ||
            (slide.multipleChoice && slide.isCorrectGetPoint) ||
            !slide.multipleChoice)) {
        return `${this.textYouHaveWonPoint()}!`
      }

      return text
    },
    textPartiallyCorrect(dataCorrectAnswers) {
      let text = ''
      if (this.$store.state.slide.isCorrectGetPoint) {
        // the more the better
        text = this.$t('youPickedCorrectAnswers', {
          msg: dataCorrectAnswers.audienceCorrectAnswers.length,
          num: dataCorrectAnswers.totalCorrectAnswers,
        })
      } else {
        // must not miss any
        if (dataCorrectAnswers.audienceMissCorrectAnswers === 1) {
          text = this.$t('youMissedCorrectAnswer', {
            msg: dataCorrectAnswers.audienceMissCorrectAnswers,
          })
        }
        text = this.$t('youMissedCorrectAnswers', {
          msg: dataCorrectAnswers.audienceMissCorrectAnswers,
        })
      }
      return `${text}<br>${this.textYouHaveWonPoint()}!`
    },
    textRunOutOfTime() {
      if (this.result.timeout) {
        return this.$t('runOutOfTime')
      }
      return ''
    },
    textYouHaveWonPoint() {
      let text = ''
      if (this.result.correct) {
        if (this.result.point === 1) {
          text = this.$t('youHaveWonPoint', {
            msg: `<strong>${Util.formatNumber(this.result.point)}</strong>`,
          })
        }
        text = this.$t('youHaveWonPoints', {
          msg: `<strong>${Util.formatNumber(this.result.point)}</strong>`,
        })
      } else {
        text = this.$t('youHaveWonPoints', {
          msg: '<strong>0</strong>',
        })
      }
      return text
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.result {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 16px;
  text-transform: uppercase;
}

.team-result__text {
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 8px;
}

@-webkit-keyframes leaves {
  0% {
    -webkit-transform: scale(1);
  }
  100% {
    -webkit-transform: scale(1.2);
  }
}

@keyframes leaves {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.text-timeout {
  font-size: 16px;
  margin-top: 0;
}
.type-answer-result {
  margin-bottom: 8px;
}
</style>
